<template>
	<div class="flex flex-col text-center text-dj-gray-dark relative">
		<span class="font-medium title">{{ $t("company.card.getInformed") }}</span>
		<span class="text-sm mt-2 mb-5 px-3 description">{{ $t("company.card.subscribe") }}</span>
		<BaseButton @click="toggleSavedCompany" type="secondary-red">
			<BaseIcon
				class="text-[24px]"
				:icon="isSavedCompany() ? 'ic:outline-favorite' : 'ic:outline-favorite-border'"
				color="#E1415A"
			/>
			<span class="ml-3">
				{{ isSavedCompany() ? $t("company.card.alreadyFollow") : $t("company.card.followCompany") }}
			</span>
		</BaseButton>
		<img
			v-if="withImage"
			class="max-w-[130px] absolute bottom-[-20px] right-[-60px]"
			src="https://res.cloudinary.com/djbs/image/upload/v1656928365/content/DreamJobs/Graphics/pic_newsletter.svg"
			:alt="$t('newsletter.subtitle')"
		/>
	</div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
	name: "FollowCompanySection",
	props: {
		location: {
			type: String,
			default: "company address",
		},
		companySlug: {
			type: String,
			required: true,
		},
		companyId: {
			type: Number,
			required: true,
		},
		withImage: {
			type: String,
			required: false,
		},
	},
	setup(props) {
		const { locale } = useI18n();
		const isAuth = useState("isAuth");
		const router = useRouter();
		const gtm = useGTM();

		function toggleSavedCompany() {
			if (isAuth.value) {
				$fetch(`/api/save-company`, {
					method: "POST",
					body: {
						companySlug: String(props.companySlug),
						xsrf: useAuth.getXsrfToken(),
						token: useCookie("token").value,
						operation: isSavedCompany() == true ? "remove-saved-company-from-user" : "save-company-to-user", // Save or Unsave
					},
				})
					.then(() => {
						// GTM tracking
						gtm.trackEvent({
							event: isSavedCompany() == true ? "b2c-company-unfollow" : "b2c-company-follow",
						});

						useAuth.updateUser();
					})
					.catch(() => {
						console.error("FollowCompanySection toggleSavedCompany");
					});
			} else {
				router.push(`/${locale.value}/login`);
			}
		}

		function isSavedCompany() {
			return isAuth.value && useAuth.isLovedCompany(props.companyId);
		}

		return {
			isSavedCompany,
			toggleSavedCompany,
		};
	},
});
</script>
